module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "merch-section single-product-page",
    attrs: {
      "xs12": "",
      "sm12": "",
      "id": "carousel-view"
    }
  }, [_c('v-layout', {
    staticClass: "dismiss-section",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-section pl-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', {
    staticClass: "ml-0",
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": ""
    }
  }, [_c('v-flex', {
    staticClass: "wrapFlex product-covers",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('div', {
    staticClass: "product-container"
  }, [_c('div', {
    staticClass: "product-side-thumbnails"
  }, _vm._l((_vm.covers), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "product-thumbnail",
      class: img === _vm.selectedCover ? 'selected' : '',
      on: {
        "click": function($event) {
          _vm.changeFeaturedImage(img)
        }
      }
    }, [_c('div', {
      staticClass: "product-covers",
      style: ({
        'background-image': ("url(" + img + ")"),
      })
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "product-cover-selected"
  }, [_c('div', {
    staticClass: "__selected",
    style: ({
      'background-image': ("url(" + _vm.selectedCover + ")"),
    })
  })])])]), _vm._v(" "), (_vm.item) ? _c('v-flex', {
    staticClass: "product-details",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "product-section px-5"
  }, [_c('div', {
    staticClass: "product-category"
  }, [_vm._v(_vm._s(_vm.productCategoryName))]), _vm._v(" "), _c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-merchant"
  }, [_c('user-tag', {
    staticClass: "tag",
    attrs: {
      "showAvatar": "",
      "user": _vm.item.merchant
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price * 100)))]), _vm._v(" "), _c('div', {
    staticClass: "product-actions"
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions pl-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-3",
    attrs: {
      "src": "/static/images/ic_share.svg",
      "width": "20"
    },
    on: {
      "click": function($event) {
        _vm.share_dialog = true
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Share")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-3",
    attrs: {
      "src": "/static/images/ic_repost.svg",
      "width": "20"
    },
    on: {
      "click": _vm.repostProduct
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Repost")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('router-link', {
    staticClass: "black--text",
    attrs: {
      "to": {
        name: 'SingleProduct',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('b', [_vm._v("View product page")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "product-description"
  }, [_vm._v("\n              " + _vm._s(_vm.item.description) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "product-options"
  }, [_c('div', {
    staticClass: "__title"
  }, [_vm._v("Select Option")]), _vm._v(" "), _c('v-select', {
    staticClass: "large",
    attrs: {
      "items": _vm.options,
      "item-text": "name",
      "placeholder": "Select option",
      "item-value": "id",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.option),
      callback: function($$v) {
        _vm.option = $$v
      },
      expression: "option"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "product-addTobag",
    attrs: {
      "round": "",
      "block": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.item.stock > 0 ? _vm.addToCart() : ''
      }
    }
  }, [(_vm.item.stock > -1) ? _c('span', [_vm._v("Add to Bag")]) : _c('span', [_vm._v("Out of Stock")])])], 1)]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7da33a6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/merchmodal.vue
// module id = 1849
// module chunks = 180